import { env } from '@percent/cause-dashboard/env'

import { SignUpReason } from '../common/hooks/useSignUpAttribution/useSignUpAttribution'
import { environments } from './environments'

interface BrandedSignupPartners {
  [partnerId: string]: {
    name: string
    logo: string
    reason: readonly string[]
  }
}

const appEnv = env.NX_PUBLIC_REACT_APP_ENV

const getCanvaPartnerId = () => {
  switch (appEnv) {
    case environments.PRODUCTION:
    default:
      return 'partner_000000CMTqjAZ1lf21cvt6GyJnUI4'
  }
}

const getAsanaPartnerId = () => {
  switch (appEnv) {
    case environments.PRODUCTION:
    default:
      return 'partner_000000CMkffPbLBHrqi7upWTjQ7Oq'
  }
}

const getMicrosoftPartnerId = () => {
  switch (appEnv) {
    case environments.PRODUCTION:
    default:
      return 'partner_000000CjsIujTyTOUojcpDuaI5Su8'
  }
}

const getAirbnbPartnerId = () => {
  switch (appEnv) {
    case environments.SANDBOX:
      return 'sandbox_partner_000000D0xXZyWTZp5E3Mt0ClM7gCe'
    case environments.PRODUCTION:
    default:
      return 'partner_000000D3Alx6PF9drLMvepvIho3Dk'
  }
}

const getTwilioPartnerId = () => {
  switch (appEnv) {
    case environments.SANDBOX:
      return 'sandbox_partner_000000CfVMTkxdFmBViV6oGjacOkC'
    case environments.PRODUCTION:
    default:
      return 'partner_000000ChDQI2W3Zpa7RJ2DQnDWolc'
  }
}

const getAdobePartnerId = () => {
  switch (appEnv) {
    case environments.SANDBOX:
      return 'sandbox_partner_000000Cmx8AijfMJ9gBS7XfPbrefg'
    case environments.PRODUCTION:
    default:
      return 'partner_000000CxmmOOgXcpEMhqfpe9h5XRA'
  }
}

const getAdyenPartnerId = () => {
  switch (appEnv) {
    case environments.SANDBOX:
      return 'sandbox_partner_000000Cw9OpSr99zyfqj6Oc7AeAO8'
    case environments.PRODUCTION:
    default:
      return 'partner_000000CzTyJnxBONlK48VvwwYq6Ve'
  }
}

const getLululemonPartnerId = () => {
  switch (appEnv) {
    case environments.SANDBOX:
      return 'sandbox_partner_000000DDoqH2VO0Qx8JC2vQzzq31c'
    case environments.PRODUCTION:
    default:
      return 'partner_000000DDor9UhA7RWU1u6s9I6me6C'
  }
}

const getAtlassianFoundationPartnerId = () => {
  switch (appEnv) {
    case environments.SANDBOX:
      return 'sandbox_partner_000000C7YyeejqAcsPa4LvnVzXupU'
    case environments.PRODUCTION:
    default:
      return 'partner_000000CBRzAHRM9WxOQCLvDOxYEIC'
  }
}

const getNikePartnerId = () => {
  switch (appEnv) {
    case environments.SANDBOX:
      return 'sandbox_partner_000000DKEcYShrOTBWrQC0u7Bzb6G'
    case environments.PRODUCTION:
    default:
      return 'partner_000000DKEcdDmoHwgLnSo9DJxh4gC'
  }
}

export const brandedSignupPartners: BrandedSignupPartners = {
  [getCanvaPartnerId()]: {
    name: 'Canva',
    logo: 'https://static.poweredbypercent.com/partnerlogo/partnerlogo_082c1387-fd55-4428-b28e-0b7f90449da6.png',
    reason: [
      SignUpReason.VERIFICATION_STATUS_CHECK,
      SignUpReason.VERIFICATION_STATUS_CHECK_FOLLOW_UP,
      SignUpReason.REVERIFICATION
    ]
  },
  [getAsanaPartnerId()]: {
    name: 'Asana',
    logo: 'https://static.poweredbypercent.com/partnerlogo/partnerlogo_f20af038-72f5-4f22-91ef-64ab7058a5b8.png',
    reason: [SignUpReason.REVERIFICATION]
  },
  [getMicrosoftPartnerId()]: {
    name: 'Microsoft',
    logo: 'https://static.poweredbypercent.com/partnerlogo/partnerlogo_a97c0f42-435c-433a-97c6-f36f474f2c43.png',
    reason: [SignUpReason.VERIFICATION_STATUS_CHECK, SignUpReason.VERIFICATION_STATUS_CHECK_FOLLOW_UP]
  },
  [getAirbnbPartnerId()]: {
    name: 'Airbnb',
    logo: 'https://static.poweredbypercent.com/partnerlogo/partnerlogo_475543526-e2138692-c79b-4f06-9163-620c91f6cbb8.png',
    reason: [SignUpReason.GRANTS_ONBOARDING]
  },
  [getTwilioPartnerId()]: {
    name: 'Twilio',
    logo: 'https://static.poweredbypercent.com/partnerlogo/partnerlogo_588a7a2d-1687-4bbd-98ee-0a9dd141611f.png',
    reason: [SignUpReason.GRANTS_ONBOARDING]
  },
  [getAdobePartnerId()]: {
    name: 'Adobe',
    logo: 'https://static.poweredbypercent.com/partnerlogo/partnerlogo_f8d2a4c6-1e7b-4a92-8f3d-b5c9e7a21064.png',
    reason: [SignUpReason.GRANTS_ONBOARDING]
  },
  [getAdyenPartnerId()]: {
    name: 'Adyen',
    logo: 'https://static.poweredbypercent.com/partnerlogo/partnerlogo_05118ac3-e6e0-47c3-bdc3-565f7e3b4e23.png',
    reason: [SignUpReason.GRANTS_ONBOARDING]
  },
  [getLululemonPartnerId()]: {
    name: 'lululemon Gives',
    logo: 'https://static.poweredbypercent.com/partnerlogo/partnerlogo_9a842479-1d72-46c1-90a1-5c70064936b4.png',
    reason: [SignUpReason.GRANTS_ONBOARDING]
  },
  [getAtlassianFoundationPartnerId()]: {
    name: 'Atlassian Foundation',
    logo: 'https://static.poweredbypercent.com/partnerlogo/partnerlogo_4d576e8d-cf35-45ac-877d-5aaa74993536.png',
    reason: [SignUpReason.GRANTS_ONBOARDING]
  },
  [getNikePartnerId()]: {
    name: 'Nike',
    logo: 'https://static.poweredbypercent.com/partnerlogo/partnerlogo_b1293c68-6f22-4adf-b993-37e0a6e1046c.png',
    reason: [SignUpReason.GRANTS_ONBOARDING]
  }
} as const
